<template>
    <div class="page-default page--order">
        <SidebarVue />
        <div class="content">
            <StatusBar
                @previousClicked="goToPrevious"
                :show-previous="true"
                :show-quota="false"
                :show-tpe="false"
                :show-menu="false"
                :title="statusTitle"
            />
            <div class="content_inner">
                <div class="infos_actions">
                    <div class="actions">
                        <Button
                            v-if="printStore.canPrint()"
                            :full-width="false"
                            @click="printStore.printOrder(orderStore.order, orderStore.tickets)"
                            icon="printer">
                            Imprimer
                        </Button>

                        <Button :full-width="false" @click="vfm.open(sendOrderModalId)" icon="send">
                            <template v-if="orderStore.order?.isProduct">
                                Envoyer le ticket
                            </template>
                            <template v-else>
                                Envoyer les billets
                            </template>
                        </Button>
                        <Button :full-width="false" v-if="orderStore.order?.totalPrice?.sellingPrice > 0" @click="vfm.open(sendInvoiceModalId)" icon="invoice">
                            Facture
                        </Button>

                        <!-- Actions reçu CB Revolut (visible si commande payée via TPE Revolut) -->
                        <Button :full-width="false" v-if="revolutTransactionId && receiptUrl" @click="vfm.open(receiptQrModalId)" icon="invoice">
                            Reçu CB
                        </Button>
                        <Button :full-width="false" v-if="revolutTransactionId" @click="vfm.open(sendReceiptModalId)" icon="send">
                            Envoyer le reçu CB
                        </Button>
                    </div>
                    <div class="infos">

                        <MTable :rows="mainTableData" :labels="mainTableLabels" />
                    </div>
                </div>

                <div v-if="orderStore.order?.isProduct" class="products">
                    <h3 class="title title--h3"><span>{{ orderStore.tickets.length }}</span> produit(s)</h3>
                    <MTable
                        :selectable="false"
                        :show-labels="true"
                        :rows="productsTableData"
                        :labels="productsTableLabels"
                    />
                </div>
                <div v-else class="tickets">
                    <h3 class="title title--h3"><span>{{ orderStore.tickets.length }}</span> billet(s)</h3>
                    <MTable
                        @rowActionClicked="rowActionClicked"
                        :selectable="false"
                        :show-labels="true"
                        :rows="ticketsTableData"
                        :labels="ticketsTableLabels"
                    />
                </div>

            </div>

            <ModalConfirm :lockScroll="false" :modal-id="sendOrderModalId" title="Envoyer les billets" @confirm="() => confirmSendOrderModalId()">
                <FormKit
                    type="form"
                    id="sendOrderModalForm"
                    v-model="sendOrderData"
                    :actions="false"
                    @submit="handleOrderSubmit"
                    >
                    <FormKit
                        type="text"
                        name="mail"
                        label="Email"
                        placeholder="Adresse e-mail"
                        :value="orderStore.order.invoiceData.email"
                        validation="required|email"
                    />
                </FormKit>
            </ModalConfirm>

            <ModalConfirm :modal-id="sendInvoiceModalId" title="Envoyer une facture" @confirm="() => confirmSendInvoice()">
                <FormKit
                    type="form"
                    id="sendInvoiceModalForm"
                    v-model="sendInvoiceData"
                    :actions="false"
                    @submit="handleInvoiceSubmit"
                    >
                    <FormKit
                        label="Email"
                        type="email"
                        name="email"
                        placeholder="Adresse e-mail"
                        :value="orderStore.order.invoiceData.email"
                        validation="required|email"
                    />
                    <div class="row--2cols">
                        <FormKit
                            type="text"
                            name="firstName"
                            label="Prénom"
                            :value="orderStore.order.invoiceData.firstName"
                            validation=""
                        />
                        <FormKit
                            type="text"
                            name="lastName"
                            label="Nom"
                            :value="orderStore.order.invoiceData.lastName"
                            validation=""
                        />
                    </div>
                    <div class="row--2cols">
                        <FormKit
                            type="text"
                            name="company"
                            :value="orderStore.order.invoiceData.company"
                            label="Société"
                            validation=""
                        />
                        <FormKit
                            type="text"
                            name="numTva"
                            label="Numéro de TVA"
                            :value="orderStore.order.invoiceData.numTva"
                            validation=""
                        />
                    </div>
                    <FormKit
                        type="textarea"
                        name="address"
                        label="Adresse"
                        :value="orderStore.order.invoiceData?.address"
                        validation=""
                    />
                </FormKit>
            </ModalConfirm>

            <RevolutReceiptQrModal
                v-if="receiptUrl"
                :modal-id="receiptQrModalId"
                :receipt-url="receiptUrl"
            />

            <ModalConfirm :modal-id="sendReceiptModalId" title="Envoyer le reçu par email" @confirm="() => confirmSendReceipt()">
                <FormKit
                    type="form"
                    id="sendReceiptModalForm"
                    v-model="sendReceiptData"
                    :actions="false"
                    @submit="handleReceiptSubmit"
                >
                    <FormKit
                        label="Email du client"
                        type="email"
                        name="email"
                        placeholder="Adresse e-mail"
                        :value="orderStore.order?.invoiceData?.email"
                        validation="required|email"
                    />
                </FormKit>
            </ModalConfirm>

        </div>
    </div>
</template>
<script setup lang="ts">
    import SidebarVue from '@/components/organisms/Sidebar.vue'
import Button from '@/components/atoms/Button.vue'
import StatusBar from '@/components/organisms/StatusBar.vue'
import MTable from '@/components/molecules/Table.vue'
import ModalConfirm from '@/components/molecules/modal/ModalConfirm.vue'
import RevolutReceiptQrModal from '@/components/molecules/modal/RevolutReceiptQrModal.vue'
import { useOrderStore } from '@/stores/OrderStore'
import { onMounted, computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { PaymentMethodEnum, PaymentMethodTypeEnum } from '@/interfaces/Order'
import { useSellingSessionStore } from '@/stores/SellingSessionStore'
import { AppPrice } from '@/tools/Price'
import { useVfm } from 'vue-final-modal'
import { submitForm } from '@formkit/vue'
import { useI18n } from 'vue-i18n'
import { usePrintStore } from '@/stores/PrintStore'
import { useEventStore } from '@/stores/EventStore'
import { GlobalHelpers } from '@/helpers/global.helper'
import { paymentTerminalService } from '@/services/payment-terminal.service'
import { toast } from 'vue3-toastify'
import * as Sentry from '@sentry/browser'

    const eventStore = useEventStore()
    const printStore = usePrintStore()
    const router = useRouter()
    const orderStore = useOrderStore()
    const sellingSessionStore = useSellingSessionStore()
    const route = useRoute()
    const vfm = useVfm()
    const { t } = useI18n();

    const sendOrderModalId = Symbol('sendOrderModalId')
    const sendOrderData = ref(null)

    const sendInvoiceModalId = Symbol('sendInvoiceModalId')
    const sendInvoiceData = ref(null)

    const sendReceiptModalId = Symbol('sendReceiptModalIdOrderDetails')
    const sendReceiptData = ref<any>(null)
    const receiptQrModalId = Symbol('receiptQrModalIdOrderDetails')

    // PaymentTransaction.id Revolut. Sert a generer / envoyer le recu CB.
    // Renseigne uniquement si la commande a ete payee via TPE Revolut.
    const revolutTransactionId = ref<string | null>(null)

    // URL publique du PDF du recu CB (= action du QR code).
    const receiptUrl = computed(() => {
        if (!revolutTransactionId.value || !orderStore.order?.token) return ''
        return paymentTerminalService.getReceiptPdfUrl(
            revolutTransactionId.value,
            orderStore.order.token,
        )
    })

    const fetchRevolutTransaction = async () => {
        if (!orderStore.order?._id) return
        try {
            const tx = await paymentTerminalService.findByOrderId(
                orderStore.order._id,
            )
            revolutTransactionId.value = tx?._id ?? null
        } catch (err) {
            Sentry.captureException(err)
            revolutTransactionId.value = null
        }
    }

    const confirmSendReceipt = () => {
        submitForm('sendReceiptModalForm')
    }

    const handleReceiptSubmit = async () => {
        if (!revolutTransactionId.value || !sendReceiptData.value?.email) return
        try {
            await paymentTerminalService.sendReceiptByEmail(
                revolutTransactionId.value,
                sendReceiptData.value.email,
            )
            toast('Le reçu a bien été envoyé')
            vfm.close(sendReceiptModalId)
        } catch (err: any) {
            Sentry.captureException(err)
            toast.error("Impossible d'envoyer le reçu")
        }
    }

    onMounted(async () => {
        const orderId = route.params.orderId.toString()
        await orderStore.fetchOrder(orderId)
        if (orderStore.order) {
            if (orderStore.order.ticketOfficeSessionId) {
                await sellingSessionStore.fetch(orderStore.order.ticketOfficeSessionId._id)
            }
            await orderStore.fetchTicketsByOrder(orderStore.order)
            // Non bloquant : si la commande n'est pas TPE Revolut,
            // revolutTransactionId reste null et les boutons sont masques.
            await fetchRevolutTransaction()
        }
    })

    const confirmSendInvoice = (async () => {
        submitForm('sendInvoiceModalForm')
    })

    const confirmSendOrderModalId = (() => {
        submitForm('sendOrderModalForm')
    })

    const statusTitle = computed(() => {
        if (eventStore.currentEvent && orderStore.order) {
            return `${eventStore.currentEvent.name} - Commande n°${orderStore.order.orderNumber}`
        }
        return ''
    })

    const handleInvoiceSubmit = (async () => {
        await orderStore.sendInvoice(orderStore.order, sendInvoiceData.value)
        vfm.close(sendInvoiceModalId)
    })

    const handleOrderSubmit = (async () => {
        await orderStore.sendTicketsToMail(orderStore.order, sendOrderData.value.mail)
        vfm.close(sendOrderModalId)
    })

    const goToPrevious = (() => {
        const isProduct = (orderStore.order?.isProduct) ? 1 : 0
        router.push({name: 'orders', query: {isProduct: isProduct}})
    })

    const printTicket = ((el) => {
        const foundTicket = orderStore.tickets.find(ticket => ticket._id === el.$id)
        if (foundTicket) {
            printStore.printTicket(orderStore.order, foundTicket)
        }
    })

    const rowActionClicked = ((el, action) => {
        switch (action) {
            case 'printTicket':
            printTicket(el)
                break;
        }
    })

     const formatDate = ((dateTime) => {
        return GlobalHelpers.formatDate(dateTime)
     })

    const productsTableLabels = computed(() => {
        return [
            {
                label: "Produit",
                value: "product",
                align: "left"
            },
            {
                label: "Quantité",
                value: "quantity",
                align: "left"
            },
            {
                label: "Prix unitaire",
                value: "unit_price",
                align: "left"
            },
            {
                label: "Prix total",
                value: "total_price",
                align: "left"
            },
        ]
    })
    const productsTableData = computed(() => {
        const products = []
        if (orderStore.tickets) {
            orderStore.tickets.forEach(ticket => {
                const foundProduct = products.find(product => product.$id === ticket.ticketTypeId)
                if (!foundProduct) {
                    products.push({
                        $id: ticket.ticketTypeId,
                        product: ticket.name,
                        quantity: 1,
                        unit_price: (ticket.price) ? new AppPrice(ticket.price.total.sellingPrice).divide100() : '--',
                        total_price: (ticket.price) ? new AppPrice(ticket.price.total.sellingPrice).divide100() : '--'
                    })
                }
                else {
                    foundProduct.quantity += 1
                    const ticketPrice = (ticket.price) ? ticket.price.total.sellingPrice : 0
                    foundProduct.total_price = new AppPrice(Number(ticketPrice) * foundProduct.quantity).divide100()
                }
            })
        }
        return products
    })

    const ticketsTableLabels = computed(() => {
        return [
            {
                label: "Tarif",
                value: "ticketType",
                align: "left"
            },
            {
                label: "Nom",
                value: "name",
                align: "left"
            },
            {
                label: "N°billet",
                value: "number",
                align: "left"
            },
            {
                label: "Total billet",
                value: "price",
                align: "left"
            },
            {
                label: "",
                value: "",
                align: "left"
            },
        ]
    })

    const ticketsTableData = computed(() => {
        if (orderStore.tickets) {
            return orderStore.tickets.map(ticket => {
                const infos = []
                const name = [ticket.name]
                const number = [ticket.ticketNumber]
                if (ticket.firstName) {
                    infos.push(ticket.firstName)
                }
                if (ticket.lastName) {
                    infos.push(ticket.lastName)
                }

                if (ticket.seat) {
                    number.push(`Place: ${ticket.seat}`)
                }


                if (ticket.addons) {
                    ticket.addons.forEach(addon => {
                        name.push(`${addon.name} (${new AppPrice(addon.price).divide100()})`)
                    })
                }


                return {
                    $id: ticket._id,
                    ticketType: name,
                    name: (infos.length) ? infos.join(' ') : '- Anonyme -',
                    number: number,
                    price: new AppPrice(ticket.price.total.sellingPrice).divide100(),
                    $actions: [
                    {
                            name: 'printTicket',
                            label: 'Imprimer',
                            icon: 'printer'
                        },
                    ]
                }
            })
        }
    })

    const mainTableLabels = computed(() => {
        return [
            {
                label: "Libellé",
                value: "label",
                align: "left"
            },
            {
                label: "Valeur",
                value: "value",
                align: "left"
            },
        ]
    })

    const mainTableData = computed(() => {
        if (orderStore.order) {
            let methodLabel = orderStore.order.payments.map((payment: any) => {
                const price = new AppPrice(payment.amount).divide100().toString()
                if (payment.method == PaymentMethodTypeEnum.custom) {
                    return `${payment.customMethod.label} (${price})`
                }
                return `${PaymentMethodEnum[payment.method]} (${price})`

            }).join(', ')

            const data = [
                {
                    label: "Opérateur",
                    value: (sellingSessionStore.currentSellingSession) ? `${sellingSessionStore.currentSellingSession.authorId?.firstName} ${sellingSessionStore.currentSellingSession.authorId?.lastName}` : '--',
                },
                {
                    label: "Date",
                    value: formatDate(orderStore.order.createdAt)
                },
                {
                    label: "Mode de paiement",
                    value: methodLabel,
                },
            ]

            // Si la commande contient des ajustements (assurance et/ou
            // frais d'édition), on détaille le sous-total + chaque ligne
            // + le total final. Sinon, ligne unique "Total commande".
            //
            // `sellingPrice` = sous-total HORS ajustements (tickets seuls).
            // `totalWithAdjustments` = montant final toutes lignes comprises.
            const insuranceAmount = orderStore.order.insurance?.amount ?? 0
            const hasInsurance = orderStore.order.hasInsurance && insuranceAmount > 0

            const adjustments = orderStore.order.totalPrice?.adjustments ?? []
            const editionFeesAdj = adjustments.find(a => a.type === 'editionFees') ?? null
            const hasEditionFees = editionFeesAdj !== null && editionFeesAdj.amount > 0
            const editionFeesAmount = editionFeesAdj?.amount ?? 0
            const editionFeesLabel = editionFeesAdj?.label || "Frais d'edition"

            const totalSelling = orderStore.order.totalPrice?.sellingPrice ?? 0
            const totalFinal =
                orderStore.order.totalPrice?.totalWithAdjustments
                ?? totalSelling

            const adjustmentCount = (hasInsurance ? 1 : 0) + (hasEditionFees ? 1 : 0)

            if (adjustmentCount === 0) {
                data.push({
                    label: "Total commande",
                    value: orderStore.order.totalPrice ? new AppPrice(totalFinal).divide100().toString() : '--'
                })
            } else {
                let subTotalLabel = "Sous-total"
                if (adjustmentCount === 1) {
                    if (hasInsurance) subTotalLabel = "Sous-total (hors assurance)"
                    else subTotalLabel = `Sous-total (hors ${editionFeesLabel.toLowerCase()})`
                }

                data.push({
                    label: subTotalLabel,
                    value: new AppPrice(totalSelling).divide100().toString()
                })

                if (hasInsurance) {
                    data.push({
                        label: "Assurance",
                        value: new AppPrice(insuranceAmount).divide100().toString()
                    })
                }

                if (hasEditionFees) {
                    data.push({
                        label: editionFeesLabel,
                        value: new AppPrice(editionFeesAmount).divide100().toString()
                    })
                }

                data.push({
                    label: "Total commande",
                    value: new AppPrice(totalFinal).divide100().toString()
                })
            }
            if (orderStore.order.invoiceData.zone) {
                data.push({
                    label: t('form.tickets.zone.label'),
                    value: orderStore.order.invoiceData.zone
                })
            }
            if (orderStore.order.invoiceData.additionalInfos) {
                data.push({
                    label: t('form.tickets.infos.label'),
                    value: orderStore.order.invoiceData.additionalInfos
                })
            }
            return data
        }
    })
</script>